module.exports = __webpack_public_path__ + "static/media/videocallimg.6e021425.png";


//////////////////
// WEBPACK FOOTER
// ./src/Images/videocallimg.png
// module id = 1169
// module chunks = 0